// Piso do relógio LWW que o cliente aceita num `updatedAt` EXPLÍCITO.
//
// Relógio de TV mente: sem RTC, antes do NTP, o boot acontece em 1970; com RTC errado,
// no futuro. Um item de sync gravado com esse relógio perde calado pra um valor
// contaminado (1970) ou TRAVA a linha contra toda escrita legítima dos outros aparelhos
// até a data dele (2037: o servidor não tem clamp, AP-115). Nenhum cliente escreve com
// relógio explícito antes de este código existir: 27/09/2026, quando a migração de
// carimbos foi escrita (o primeiro chamador). O teto é o `Date.now()` do momento do
// enqueue (nada no futuro). O teto de verdade contra o futuro só se resolve no
// servidor (AP-115); aqui é o que o cliente consegue.

export const SYNC_CLOCK_MIN_MS = Date.UTC(2026, 8, 27)

/** O `updatedAt` (ISO) está dentro do que o cliente aceita: ≥ o piso e ≤ agora. */
export function isAcceptableClock(updatedAtIso: string, nowMs: number = Date.now()): boolean {
  const ms = Date.parse(updatedAtIso)
  return Number.isFinite(ms) && ms >= SYNC_CLOCK_MIN_MS && ms <= nowMs
}
